import { useMemo } from 'react';

import {
  checkIsCmsPromoAvailable,
  checkIsEasterPromoAvailable,
} from '../helpers';
import { useBonanzaPromo } from './useBonanzaPromo';
import { useCommonStore } from '@/store';

export const usePromotionsAvailability = () => {
  const user = useCommonStore.use.user();
  const cmsConfig = useCommonStore.use.cmsConfig();

  const { isPromoCompleted } = useBonanzaPromo();

  const isBonanzaPromoAvailable = useMemo(() => {
    if (!cmsConfig || !cmsConfig.bonanzaPromo?.dateRange) return;

    const availableByDateAndGroups = checkIsCmsPromoAvailable(
      cmsConfig.bonanzaPromo.availableByDate,
      user
    );

    if (isPromoCompleted) return false;

    return availableByDateAndGroups;
  }, [cmsConfig, isPromoCompleted, user]);

  const isScratchGameAvailable = useMemo(
    () =>
      checkIsCmsPromoAvailable(cmsConfig?.scratchGame.availableByDate, user),
    [cmsConfig?.scratchGame.availableByDate, user]
  );

  const isFortuneWheelAvailable = useMemo(
    () =>
      checkIsCmsPromoAvailable(cmsConfig?.fortuneWheel.availableByDate, user),
    [cmsConfig?.fortuneWheel.availableByDate, user]
  );

  const isEasterAvailable = useMemo(
    () => checkIsEasterPromoAvailable(user),
    [user]
  );

  const isAnyPromoAvailable = useMemo(
    () =>
      isBonanzaPromoAvailable ||
      isScratchGameAvailable ||
      isFortuneWheelAvailable ||
      isEasterAvailable,
    [
      isBonanzaPromoAvailable,
      isScratchGameAvailable,
      isFortuneWheelAvailable,
      isEasterAvailable,
    ]
  );

  return {
    isEasterAvailable,
    isAnyPromoAvailable,
    isBonanzaPromoAvailable,
    isScratchGameAvailable,
    isFortuneWheelAvailable,
  };
};
